angular.module("dpw.services").factory("helpers", [
    "platformTypes",
    "$timeout",
    "usagePlanLimits",
    "apiGroupTypes",
    "voidImageUrlPlaceHolder",
    "XSRFProtectFilter",
    "apiRefEntries",
    "adminSiteEntries",
    "$q",
    "mixpanelService",
    "tutorialUrlPrefix",
    "$window",
    "appStatusShortNames",
    function (
        platformTypes,
        $timeout,
        usagePlanLimits,
        apiGroupTypes,
        voidImageUrlPlaceHolder,
        XSRFProtectFilter,
        apiRefEntries,
        adminSiteEntries,
        $q,
        mixpanelService,
        tutorialUrlPrefix,
        $window,
        appStatusShortNames
    ) {
        var hiddenPre = document.createElement("pre");
        var apiReferencePageDir = "/api-reference/";
        var platformTypesObj = {};
        _.forEach(platformTypes, function (item) {
            platformTypesObj[item.id] = item.text;
        });

        function isMac() {
            return (
                _.get(navigator, "platform", "")
                    .toUpperCase()
                    .indexOf("MAC") >= 0
            );
        }

        return {
            /**
             * Check whether it is using IE9
             */
            isIE9: function () {
                return $("html").is(".ie9");
            },

            isIE: function () {
                var u = window.navigator.userAgent;
                return (
                    u.indexOf("MSIE ") > 0 ||
                    u.indexOf("Trident/") > 0 ||
                    u.indexOf("Edge/") > 0
                );
            },

            isChrome: function () {
                return window.navigator.userAgent.indexOf("Chrome") > 0;
            },
            isSafari: function () {
                var ua = window.navigator.userAgent;
                return ua.indexOf("Safari") >= 0 && ua.indexOf("Chrome") < 0;
            },

            brand: {
                getPartnerName: function (id) {
                    var NAME_LIST = {
                        3420: "AT&T Office@Hand",
                        3460: "AT&T Office@Hand",
                        7310: "TELUS Business Connect™",
                        7710: "BT Cloud Work",
                        6010: "Avaya Cloud Office",
                        2020: "Atos Unify Office",
                        2110: "Alcatel Rainbow Office",
                        2210: "Verizon",
                        7010: "Vodafone Business UC",
                        4210: "RingCentral mit ecotel",
                        4810: "RingCentral for Symphony",
                        4610: "RingCentral with Eastlink",
                        4710: "RingCentral mit 1&1 Connected Calls",
                        2030: "RingCentral mit Telekom",
                        2040: "Unify Office by RingCentral",
                        4910: "Frontier plus RingCentral",
                        2050: "RingCentral with Sunrise",
                        5110: "Charter SMB",
                        5210: "Charter Enterprise",
                    };

                    return NAME_LIST[id];
                }
            },

            /**
             * Rebranding
             * @param  {String} brandId
             * @param  {Object} messageKey
             * @param  {Boolean} [isMobile=false]
             * @return {String}
             */
            getBrandedMessage: function (brandId, messageKey, isMobile) {
                var messages = RCDPW.Lang.Brands;
                var messageKeys = (isMobile ? ".Mobile." : ".") + messageKey;
                brandId = brandId || RCDPW.Lang.Brands.DefaultBrand;
                return (
                    _.get(messages, brandId + messageKeys) ||
                    _.get(messages, messages.DefaultBrand + messageKeys)
                );
            },

            /**
             * Return community link address
             * @return {[String]} [community link]
             */
            getGoToCommunityUrl: function () {
                return RCDPW.goToCommunityUrl;
            },

            getGoToEngageCommunityUrl: function () {
                return RCDPW.goToCommunityUrl;
            },

            /**
             * @param {String} path - Page url.
             * @returns {boolean}
             */
            isAPIExplorerPages: function (path) {
                return path.indexOf(apiReferencePageDir) > -1;
            },

            isSwaggerPages: function (path) {
                return path.indexOf(apiReferencePageDir) > -1;
            },

            matchPage: function (pageEntry) {
                return (
                    window.location.pathname.toLowerCase() ===
                    pageEntry.href.toLowerCase()
                );
            },

            /**
             * Convert HTML Entities into HTMl Tags
             * @param {*} string
             * @returns {string|string}
             */
            decodeEntities: function (string) {
                string = string + "";
                hiddenPre.innerHTML = string.replace(/</g, "&lt;");
                return hiddenPre.textContent || hiddenPre.innerText || "";
            },

            isMac: isMac,
            /**
             * Determine if the open new tab key is pressed
             *
             * @param e: event
             * @returns {boolean}
             */
            isNewTabKey: function (e) {
                return isMac() ? e.metaKey : e.ctrlKey;
            },
            /**
             * Determine if the num is an integer or not
             * @param {Number} num
             * @returns {boolean}
             */
            isInteger: function (num) {
                return num % 1 === 0;
            },
            /**
             * Convert #content which contains youtube.com/watch?v=xxx into iframe.
             *
             * @param {String} content - Content to be converted.
             */
            convertYoutubeUri: function (content) {
                if (angular.isString(content)) {
                    var re = /(href=")?(?:http|https):\/\/(?:(?:www\.)?youtube.com\/)(?:v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&\?]{11})(&(?:#038;)?\w+=[^ <]+)*/gi;
                    var reShortUri = /(href=\\")?(?:http|https):\/\/(?:(?:www\.)?youtu.be\/)([^#&\?]{11})(\?\w+=[^ <]+(?:&(?:#038;)?\w+=[^ <]+)*)?/gi;

                    content = content
                        .replace(re, replacer)
                        .replace(reShortUri, replacer);
                }
                return content;

                function replacer(match, hasHref, videoId, parameters) {
                    return hasHref
                        ? match.substring(6)
                        : '<iframe width="720" height="404" src="https://www.youtube.com/embed/' +
                        videoId +
                        formatParams(parameters) +
                        '" frameborder="0" allowfullscreen></iframe>';
                }

                function formatParams(params) {
                    var formatted = params || "";
                    if (formatted.indexOf("&") > -1) {
                        formatted = "?" + formatted.substring(1);
                    }
                    return formatted;
                }
            },

            /**
             * Determine if the array contains a given value
             *
             * @deprecated Please use `_.includes` instead.
             * @param arr
             * @param item
             * @returns {boolean}
             */
            contains: function (arr, item) {
                if (!angular.isArray(arr)) {
                    return false;
                }
                return $.inArray(item, arr) >= 0;
            },

            /**
             * Return an set of source's items which meet the criteria
             *
             * @param source
             * @param criteria
             */
            find: function (source, criteria) {
                var result = [];
                angular.forEach(source, function (item) {
                    var isEqual = true;
                    for (var keyName in criteria) {
                        if (criteria.hasOwnProperty(keyName)) {
                            if (criteria[keyName] != item[keyName]) {
                                isEqual = false;
                                break;
                            }
                        }
                    }
                    isEqual && result.push(item);
                });
                return result;
            },

            /**
             * Return if the given url is a api url
             *
             * @param url
             * @returns {boolean}
             */
            isAPICall: function (url) {
                return url.indexOf("/api/") === 0;
            },

            /**
             * Return the platform type value according to the id
             * @param id
             * @returns {*|string}
             */
            getPlatformTypeTextById: function (id) {
                return platformTypesObj[id] || "";
            },

            /**
             * Return if the all the properties in the obj is empty or null
             *
             * @deprecated
             * @param obj
             * @returns {boolean}
             */
            isAllFieldsEmpty: function (obj) {
                var result = true; // init state to empty

                return _.every(obj, function (item) {
                    return _.isEmpty(item);
                });
            },

            /**
             * Creates and returns a new debounced version of the passed function which will postpone
             *   its execution until after wait milliseconds have elapsed since the last time it was invoked.
             *
             * @param {Function} fn: the function to execute
             * @param {Number} ms: milliseconds to delay execution
             */
            debounce: (function () {
                var timer;
                return function (fn, ms) {
                    $timeout.cancel(timer);
                    timer = $timeout(fn, ms);
                };
            })(),

            /**
             * Page parser - check if the request page param is valid, and transform it if it was invalid.
             *
             * @param {String|Number} page - Page to check.
             * @param {Object} [options={}]
             * @param {Number} [options.min=0] - Minimum page.
             * @param {Number} [options.total] - Total records.
             * @param {Number} [options.pageSize] - Page size.
             * @param {Number} [options.defaults=1] - Default page if page is invalid.
             *
             * @return {Object}
             */
            parsePage: function (page, options) {
                options = options || {};
                var min = options.min || 1;
                var max;
                var defaults = options.defaults || 1;
                var isValid = true;

                if (options.total && options.pageSize) {
                    max = Math.ceil(options.total / options.pageSize);
                }

                if (!/^[0-9]+$/.test(page)) {
                    isValid = false;
                } else {
                    page = parseInt(page, 10);
                    isValid = page && page >= min;
                    max && (isValid = isValid && page <= max);
                }

                return {
                    valid: Boolean(isValid),
                    page: isValid ? page : defaults
                };
            },
            /**
             * Transform location.search into object.
             * For Example: path.html?id=12 => {id: 12}
             *
             * @param {String} [uri=location.search] - URI to parse.
             *
             * @returns {Object}
             */
            getSearchParams: function (uri) {
                var params = {};
                var query = (uri || location.search).split("?")[1];
                var re = /([^&=]+)=?([^&]*)/g;
                var match;

                while ((match = re.exec(query))) {
                    if (match[1] !== "undefined") {
                        var name = decode(match[1]);
                        params[name] = decode(match[2]);
                    }
                }

                return params;

                function decode(str) {
                    return decodeURIComponent(str.replace(/\+/g, " "));
                }
            },

            /**
             * Test if #link is external.
             *
             * @param {String} link
             * @returns {boolean}
             */
            isExternalLink: function (link) {
                link = String(link);
                if (!link) {
                    return false;
                }
                var internalLinkPattern = new RegExp(location.host);
                return !internalLinkPattern.test(link);
            },

            /**
             * Test if #link is email.
             *
             * @param {String} link
             * @returns {boolean}
             */
            isEmailLink: function (link) {
                return _.startsWith(link, "mailto:");
            },

            /**
             * Test whether the status of WordPress API returned data is 'SUCCESS',
             *
             * @param {Object} data - response data from API
             */
            isWordPressCallSuccess: function (data) {
                var result =
                    data && data.status && data.status.status === "SUCCESS";
                return (
                    result && (_.isNumber(data.total) || _.isObject(data.post))
                );
            },

            /**
             * Used by usage plan feature to make a ordered limits records array
             *
             * @param limits
             * @returns {*|Array}
             */
            buildOrderedLimits: function (allGroups, limits) {
                var base = usagePlanLimits.map(function (item) {
                    var context = limits[item] || {};
                    return convertLimit(item, context, apiGroupTypes.base);
                });

                var extended = allGroups
                    .filter(function (limit) {
                        return !_.includes(usagePlanLimits, limit);
                    })
                    .sort(function (item1, item2) {
                        return item1.localeCompare(item2);
                    })
                    .map(function (item) {
                        var context = limits[item] || {};
                        return convertLimit(item, context, apiGroupTypes.extended);
                    });

                return base.concat(extended);

                function convertLimit(name, context, type) {
                    return {
                        name: name,
                        limit: context.limit,
                        timeframeSeconds: context.timeframeSeconds,
                        penaltyTimeoutSeconds: context.penaltyTimeoutSeconds,
                        type: type
                    };
                }
            },

            /**
             * Build available usage plans
             *
             * @param options
             */
            buildAvailableUsagePlans: function (options) {
                var usagePlans = options.usagePlans;
                var currentUsagePlan = options.currentUsagePlan;
                var isFound = _.findIndex(usagePlans, function (plan) {
                    return plan.id == currentUsagePlan.id;
                });
                if (-1 == isFound) {
                    // not found
                    usagePlans.unshift(currentUsagePlan);
                }
            },

            partnerType: {
                shouldShow: function (organization) {
                    return _.get(organization, "type", "") !== "Native";
                },
                getLabel: function (partnerType) {
                    return partnerType === "Blank" ? "-" : partnerType;
                },
                getValue: function (partnerType) {
                    return partnerType === "-" ? "Blank" : partnerType;
                }
            },

            /**
             * Make the KeyName field the only sort criteria
             * @param sortObj
             * @param keyName
             */
            singleFieldSort: function (sortObj, keyName, isAsc) {
                _.forEach(sortObj, function (item, keyName) {
                    sortObj[keyName] = null;
                });
                sortObj[keyName] = isAsc;
            },

            /**
             * Check if the url of a fileObj is a place holder
             * @param fileObj
             * @returns {boolean}
             */
            isPlaceHolderUrl: function (fileObj) {
                return _.get(fileObj, "url", null) === voidImageUrlPlaceHolder;
            },

            /**
             * Filter out all the unnecessary data before sending request to the server
             *
             * @param {Object} data - original app data which normally is '$scope.application'.
             * @returns {Object} The filtered app data.
             */
            appDataFilter: function (data) {
                var appData = angular.copy(data);

                appData.redirectUris = _.map(appData.redirectUris, function (
                    item
                ) {
                    return item.uri;
                });

                // Remove redirect URIs with empty string
                appData.redirectUris = _.compact(appData.redirectUris);

                return appData;
            },
            resUtil: {
                isForbidden: function (data) {
                    return _.get(data, "status.status") == "FORBIDDEN";
                },
                isInvalidPara: function (data) {
                    return _.get(data, "status.status") == "INVALID_PARAMETER";
                },
                isTokenInvalid: function (data) {
                    return _.get(data, "status.status") === "TOKEN_INVALID";
                },
                isAdminNoPermission: function (data) {
                    return (
                        _.get(data, "status.status") === "ADMIN_NO_PERMISSION"
                    );
                },
                isDeveloperNoPermission: function (data) {
                    return _.get(data, "status.message") === "NO_PERMISSION";
                },
                isSuccess: function (data) {
                    return _.get(data, "status.status") == "SUCCESS";
                },
                isNotLogin: function (data) {
                    return _.get(data, "status.status") == "NOT_LOGGED_IN";
                },
                isNotLoginHasAutoLogin: function (data) {
                    return (
                        _.get(data, "status.status") ==
                        "NOT_LOGGED_IN_WITH_AUTO_LOGIN"
                    );
                },
                getMessage: function (data) {
                    return _.get(data, "status.message");
                }
            },
            getApiRefUrl: function (topic) {
                return [
                    apiRefEntries.baseUrl,
                    apiRefEntries.entries[topic]
                ].join("");
            },
            getAdminSiteUrl: function (pageName, context) {
                var baseUrl =
                    RCDPW.adminSiteDomain ||
                    "https://ai-developers-dpw02.int.rclabenv.com";
                var entry = [baseUrl, adminSiteEntries[pageName]].join("");
                _.forEach(context, function (value, key) {
                    entry = entry.replace(
                        new RegExp("{" + key + "}", "g"),
                        value
                    );
                });
                return entry;
            },
            /**
             * Wrapper function for XSRFProtect filter.
             *
             * @param {String} input
             * @returns {String}
             */
            XSRFProtect: function (input) {
                /*jshint -W064*/
                return XSRFProtectFilter(input);
            },
            appStateUtil: (function () {
                function getStatus(app) {
                    return _.get(app, "appState.status");
                }

                function getStatusDisplayName(app) {
                    return _.get(app, "appState.statusDisplayName");
                }

                function getStatusShortName(app) {
                    var status = getStatus(app);
                    return _.get(appStatusShortNames, status);
                }

                return {
                    getStatus: getStatus,
                    getStatusDisplayName: getStatusDisplayName,
                    getStatusShortName: getStatusShortName,
                    isInitial: function (app) {
                        return getStatus(app) === "Initial";
                    },
                    isInDev: function (app) {
                        return _.includes(
                            ["Initial", "Declined"],
                            getStatus(app)
                        );
                    },
                    isGraduated: function (app) {
                        return _.includes(
                            ["Active", "Suspended", "Blocked", "Unblocking"],
                            getStatus(app)
                        );
                    },
                    canEditRedirectURI: function (app) {
                        return _.includes(
                            ["Initial", "Declined", "Active"],
                            getStatus(app)
                        );
                    },
                    /**
                     * Get a css class to designate color for app status.
                     *
                     * @param    {Object|String}  options.data          - the `application` object or app status.
                     * @param    {Boolean}        options.isAdminSite
                     * @returns  {String}         css class.
                     */
                    getColorClassByAppStatus: function (options) {
                        var data = options.data;
                        var status = _.isObject(data) ? getStatus(data) : data;

                        return options.isAdminSite
                            ? getColorClassOnAdminSite(status)
                            : getColorClassOnDeveloperSite(status);

                        function getColorClassOnAdminSite(status) {
                            var classPrefix = "dpw-app-status-text-";
                            var statusColorMapping = {
                                Initial: "gray",
                                Suspended: "gray",
                                Pending: "orange",
                                Reviewing: "orange",
                                Unblocking: "orange",
                                Declined: "red",
                                Blocked: "red",
                                Active: "green"
                            };
                            return classPrefix + statusColorMapping[status];
                        }

                        function getColorClassOnDeveloperSite(status) {
                            var classConfig = {
                                Blocked: "dpw-app-status-text-blocked",
                                Active: "dpw-app-status-text-active"
                            };
                            return _.get(
                                classConfig,
                                status,
                                "dpw-app-status-text-default"
                            );
                        }
                    }
                };
            })(),

            /**
             * get attributes for links: target & class
             * @param {String} url: the url that need to be formatted
             * @returns {Object} a object contains target and class
             */
            getFormattedLinkAttrs: function (url) {
                var attrs = {class: "blueText"};
                attrs["target"] = _.startsWith(url, "mailto:")
                    ? "_self"
                    : "_blank";
                return attrs;
            },

            removeWhiteSpaces: function (str) {
                if (str) {
                    return str.replace(/\s+/g, "");
                }
            },

            getOffsetTopRelativeToRoot: function (element) {
                var offsetTop = element.offsetTop;
                while ((element = element.offsetParent)) {
                    offsetTop += element.offsetTop;
                }
                return offsetTop;
            },

            isTutorialUrl: function (url) {
                url = _.trim(url);
                return _.startsWith(url, tutorialUrlPrefix);
            },

            /**
             * @description Un-wrap values from language like "en-US".
             * @param {Array|any} data
             * @example
             * [
             *   {
             *     adImage: { en-US: "//images.ctfassets.net/2.png" },
             *     adId: { en-US: "topmenu_resources" },
             *   }
             * ]
             * will be converted to
             * [
             *   { adImage: "//images.ctfassets.net/2.png" },
             *   { adId: "topmenu_resources" }
             * ]
             */
            formatContentfulData: function (data) {
                return Array.isArray(data)
                    ? data.map(function (item) {
                        _.forEach(item, function (languages, key) {
                            item[key] = languages["en-US"];
                        });
                        return item;
                    })
                    : data;
            },

            addCacheBuster: function (url) {
                return url + "?v=" + RCDPW.version;
            },
            handleSortObj: function (sortObj) {
                var sortOrder = [];
                var sortBy = [];
                var result = [];
                angular.forEach(sortObj, function (item, keyName) {
                    if (item == null) {
                        return;
                    }
                    sortBy.push(keyName);
                    sortOrder.push(item ? "asc" : "desc");
                });
                result.push(
                    "sortOrder=" + encodeURIComponent(sortOrder.join(","))
                );
                result.push("sortBy=" + encodeURIComponent(sortBy.join(",")));

                return result.join("&");
            },
            handleExportParams: function (params) {
                var self = this;
                var results = [];
                Object.keys(params).forEach(function (key) {
                    var value = params[key];
                    if (
                        _.isNull(value) ||
                        _.isUndefined(value) ||
                        value === ""
                    ) {
                        return;
                    }

                    if (key === "sortObj") {
                        results.push(self.handleSortObj(value));
                    } else if (Array.isArray(value)) {
                        value.forEach(function (v) {
                            results.push(
                                encodeURIComponent(key) +
                                "=" +
                                encodeURIComponent(v)
                            );
                        });
                    } else {
                        results.push(
                            encodeURIComponent(key) +
                            "=" +
                            encodeURIComponent(value)
                        );
                    }
                });
                return results.join("&");
            },
            isSingularForm: function (number) {
                return number === 1;
            },
            buildAngularAppUrl: function (appId, pageName) {
                return "/console/application/" + appId + "/" + pageName;
            },
            onlinePortalLinks: {
                prod: function (url) {
                    var a = document.createElement("a");
                    a.href = url;
                    return a.protocol + "//" + a.host;
                }
            },
            isApiRef: function () {
                var pathname = window.location.pathname;
                var apiRefPaths = [
                    "/api-reference",
                    "/engage/digital/api-reference",
                    "/engage/voice/api-reference"
                ];
                return apiRefPaths.some(function (path) {
                    return _.startsWith(pathname, path);
                });
            },
            generateRandomString: function (length) {
                var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
                var result = '';
                for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
                return result;
            },
            isAbsoluteUrl: function (url) {
                return RegExp('^https?://', 'i').test(url);
            },
            isLoginPage: function () {
                var pathname = $window.location.pathname;
                return _.startsWith(pathname, '/login');
            },
            isAppListPage: function () {
                var url = $window.location.pathname + $window.location.hash;
                return _.startsWith(url, '/my-account.html#/applications');
            },
            resolveError: function (err) {
                var code = _.get(err, 'status.message') || _.get(err, 'platformErrors.errorCode');
                var status = _.get(err, 'status.status');
                var message = _.get(err, 'platformErrors.message');

                if (status === 'PLATFORM_ERROR' && (code || '').startsWith('PWD-')) {
                    code = 'PLATFORM_ERROR_PWD';
                }

                return {
                    code: code,
                    message: message
                }
            },
            isLessThan24Hours: function (preTime) {
                if (!preTime) {
                    return false;
                }

                var nowTime = new Date().getTime();

                var diffHours = Math.abs((nowTime - preTime) / (1000 * 60 * 60));

                return diffHours < 24;
            }
        };
    }
]);
